import _Button from "@material-ui/core/esm/Button";
import _cloneDeep from "lodash/cloneDeep";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { capitalize } from 'swag-common/utils/strings';
import { Color } from 'swag-client-common/components/ui/color';
import { DesignUploadMode } from 'swag-common/interfaces';
import Drawer from '../../ui/drawer';
import classes from './size-editor-popup.scss';
const getSizes = (items, box) => {
  if (!items) {
    return {};
  }
  return items.reduce((all, next) => {
    const {
      variants,
      prod: {
        size,
        variants: prodVariants
      },
      sizeInd,
      _id
    } = next;
    const boxProduct = box.products.find(p => p._id === next.prodId) || next.prod;
    if (!boxProduct) {
      return all;
    }
    return _objectSpread({}, all, {
      [next.prodId]: {
        sizeInd,
        itemId: _id,
        name: boxProduct.name,
        size: boxProduct.designUploadMode === DesignUploadMode.fullDesign ? null : boxProduct.productSize,
        variants,
        color: prodVariants && prodVariants.length > 0 ? prodVariants[variants[0].variantIndex].color : null,
        isSizeExists: !boxProduct.sizeDependentPrice && size && size.options
      }
    });
  }, {});
};
class SizeEditorPopup extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.open && nextProps.item && nextProps.item._id && nextProps.item._id !== prevState.itemId) {
      const {
        item: {
          _id,
          prod,
          products
        }
      } = nextProps;
      return {
        itemId: _id,
        items: getSizes(products, prod)
      };
    }
    if (!nextProps.open) {
      return {
        itemId: null
      };
    }
    return null;
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      itemId: null,
      items: {}
    };
    this.handleClickSave = this.handleClickSave.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
  }
  handleSizeChange(id, sizeIndex) {
    const items = _cloneDeep(this.state.items);
    items[id].sizeInd = sizeIndex;
    items[id].variants[0] = {
      variantIndex: items[id].variants[0].variantIndex,
      quantities: items[id].variants[0].quantities.map((quantity, index) => index === sizeIndex ? 1 : 0)
    };
    this.setState({
      items
    });
  }
  handleClickSave() {
    const {
      item,
      onSave
    } = this.props;
    const updatedItem = _cloneDeep(item);
    updatedItem.products = updatedItem.products.reduce((all, next) => [...all, _objectSpread({}, next, {
      sizeInd: this.state.items[next.prodId].sizeInd,
      variants: this.state.items[next.prodId].variants
    })], []);
    onSave(updatedItem);
  }
  render() {
    const {
      open,
      onClose
    } = this.props;
    const {
      items
    } = this.state;
    return /*#__PURE__*/React.createElement(Drawer, {
      open: open,
      onClose: onClose,
      headerTitle: "Edit size"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.title
    }, "Choose size"), /*#__PURE__*/React.createElement("div", null, Object.keys(items).map(id => {
      if (!items[id] || !items[id].isSizeExists) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        key: id
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.info
      }, /*#__PURE__*/React.createElement(Color, {
        color: items[id].color
      }), /*#__PURE__*/React.createElement("span", {
        className: classes.title
      }, capitalize(items[id].name))), /*#__PURE__*/React.createElement("div", null, items[id].size.options.map((label, sizeIndex) => /*#__PURE__*/React.createElement(_Button, {
        size: "small",
        variant: "contained",
        key: `${id}-${label}`,
        onClick: () => this.handleSizeChange(id, sizeIndex),
        className: classnames(classes.size, {
          [classes.active]: items[id].sizeInd === sizeIndex
        })
      }, label))));
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.footer
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.button,
      type: "primary",
      onClick: this.handleClickSave
    }, "Save"))));
  }
}
export default SizeEditorPopup;